import React, { useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FiImage,
  FiUploadCloud,
  FiSmartphone,
  FiAlertTriangle,
  FiX,
  FiCheck,
} from "react-icons/fi";
import {
  setPhotoDetails,
  setphotoScooring,
  setpropertyScooring,
  setPostPropertyStepsStatus,
} from "../../../redux/property/PropertySlice";

const StepTwoPhotos = ({ onBack, onNext }) => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const { PhotoDetails } = useSelector((state) => state.Property);

  const [images, setImages] = useState(
    Array.isArray(PhotoDetails) ? PhotoDetails : []
  );
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = (fileList) => {
    const filesArray = Array.from(fileList);
    const newImageObjs = filesArray.map((file) => ({
      file: file,
      name: file.name,
      url: URL.createObjectURL(file),
    }));

    const updated = [...images, ...newImageObjs].slice(0, 50);
    setImages(updated);
    dispatch(setPhotoDetails(updated));
    dispatch(setphotoScooring(updated.length > 0 ? 18 : 0));
    dispatch(setpropertyScooring());
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFiles(e.dataTransfer.files);
    }
  };

  const handleRemoveImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
    dispatch(setPhotoDetails(updated));
    dispatch(setphotoScooring(updated.length > 0 ? 18 : 0));
    dispatch(setpropertyScooring());
  };

  const handleContinue = () => {
    dispatch(setPostPropertyStepsStatus(4)); // Step 4 Pricing
    if (onNext) onNext();
  };

  const handleGoBack = () => {
    dispatch(setPostPropertyStepsStatus(0)); // Step 1 Details
    if (onBack) onBack();
  };

  return (
    <div className="mgh-step-two">
      <div className="mgh-post-card">
        {/* Header */}
        <div className="mgh-post-banner-header">
          <div className="mgh-post-banner-icon">
            <FiImage />
          </div>
          <div>
            <h2 className="mgh-post-banner-title">
              Add photos of your property <span>(Optional)</span>
            </h2>
            <p className="mgh-post-banner-sub">
              A picture is worth a thousand words. 87% of buyers look at photos before buying.
            </p>
          </div>
        </div>

        {/* 2-Column Upload Methods */}
        <div className="mgh-photo-grid">
          {/* Desktop Upload Dropzone */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
              <FiImage style={{ color: "#ea580c" }} />
              <strong style={{ fontSize: "14px", color: "#334155" }}>
                Upload from desktop
              </strong>
            </div>

            <div
              className={`mgh-dropzone ${isDragging ? "dragging" : ""}`}
              onDragOver={(e) => {
                e.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current && fileInputRef.current.click()}
            >
              <input
                type="file"
                multiple
                accept="image/*"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={(e) => {
                  if (e.target.files) handleFiles(e.target.files);
                }}
              />
              <div className="mgh-dropzone-icon">
                <FiUploadCloud />
              </div>
              <div className="mgh-dropzone-title">Drag and drop your photos here</div>
              <div className="mgh-dropzone-desc">
                Upload up to 50 photos (Max size 10 MB each)
                <br />
                Supported formats: JPG, JPEG, PNG, WEBP, GIF, HEIC, HEIF
              </div>
              <button
                type="button"
                className="mgh-btn-primary"
                style={{ padding: "10px 22px", fontSize: "13.5px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  fileInputRef.current && fileInputRef.current.click();
                }}
              >
                Upload Photos Now
              </button>
            </div>
          </div>

          {/* OR Divider */}
          <div className="mgh-or-divider">
            <div className="mgh-or-badge">OR</div>
          </div>

          {/* Phone QR Upload */}
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
              <FiSmartphone style={{ color: "#ea580c" }} />
              <strong style={{ fontSize: "14px", color: "#334155" }}>
                Upload from phone
              </strong>
            </div>

            <div className="mgh-phone-upload-card">
              <div className="mgh-qr-frame">
                {/* Clean inline SVG QR code mockup */}
                <svg
                  width="130"
                  height="130"
                  viewBox="0 0 130 130"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="130" height="130" fill="white" />
                  {/* Top-left position marker */}
                  <rect x="10" y="10" width="35" height="35" rx="4" fill="#0f172a" />
                  <rect x="17" y="17" width="21" height="21" fill="white" />
                  <rect x="23" y="23" width="9" height="9" fill="#ea580c" />
                  {/* Top-right position marker */}
                  <rect x="85" y="10" width="35" height="35" rx="4" fill="#0f172a" />
                  <rect x="92" y="17" width="21" height="21" fill="white" />
                  <rect x="98" y="23" width="9" height="9" fill="#ea580c" />
                  {/* Bottom-left position marker */}
                  <rect x="10" y="85" width="35" height="35" rx="4" fill="#0f172a" />
                  <rect x="17" y="92" width="21" height="21" fill="white" />
                  <rect x="23" y="98" width="9" height="9" fill="#ea580c" />
                  {/* Data blocks */}
                  <rect x="52" y="15" width="6" height="18" fill="#0f172a" />
                  <rect x="65" y="12" width="12" height="6" fill="#0f172a" />
                  <rect x="65" y="24" width="6" height="12" fill="#ea580c" />
                  <rect x="15" y="52" width="18" height="6" fill="#0f172a" />
                  <rect x="25" y="65" width="12" height="12" fill="#0f172a" />
                  <rect x="42" y="42" width="8" height="8" fill="#ea580c" />
                  <rect x="56" y="42" width="18" height="8" fill="#0f172a" />
                  <rect x="80" y="52" width="8" height="18" fill="#0f172a" />
                  <rect x="94" y="60" width="18" height="8" fill="#0f172a" />
                  <rect x="52" y="60" width="12" height="12" fill="#0f172a" />
                  <rect x="70" y="70" width="12" height="6" fill="#ea580c" />
                  <rect x="52" y="80" width="8" height="18" fill="#0f172a" />
                  <rect x="66" y="86" width="18" height="8" fill="#0f172a" />
                  <rect x="90" y="86" width="12" height="12" fill="#0f172a" />
                  <rect x="80" y="105" width="18" height="8" fill="#ea580c" />
                  <rect x="52" y="105" width="18" height="8" fill="#0f172a" />
                  <rect x="105" y="105" width="10" height="10" fill="#0f172a" />
                </svg>
              </div>
              <p style={{ fontSize: "12.5px", color: "#64748b", margin: 0 }}>
                Scan this QR code with your phone to upload photos directly
              </p>
            </div>
          </div>
        </div>

        {/* Thumbnail Preview of Uploaded Images */}
        {images.length > 0 && (
          <div style={{ marginBottom: "20px" }}>
            <h4 style={{ fontSize: "14px", fontWeight: "700", marginBottom: "8px" }}>
              Uploaded Photos ({images.length})
            </h4>
            <div className="mgh-image-preview-grid">
              {images.map((img, i) => (
                <div key={i} className="mgh-image-preview-item">
                  <img src={img.url || img} alt={`Uploaded ${i}`} />
                  <button
                    type="button"
                    className="mgh-image-remove-btn"
                    onClick={() => handleRemoveImage(i)}
                  >
                    <FiX />
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Warning Alert Notice */}
        <div className="mgh-warning-alert">
          <FiAlertTriangle className="mgh-warning-alert-icon" />
          <div className="mgh-warning-alert-text">
            <strong>Without photos your ad will be ignored by buyers.</strong>
            <br />
            Show your complete property by adding other area photos like kitchen, balcony, etc.
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mgh-form-actions">
          <button
            type="button"
            className="mgh-btn-secondary"
            onClick={handleGoBack}
          >
            Back
          </button>
          <button
            type="button"
            className="mgh-btn-primary"
            onClick={handleContinue}
          >
            {images.length > 0 ? "Continue" : "Continue without photos"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepTwoPhotos;
